<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class='flex md12 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.displayName"
              label="权限名称"
              removable
              :messages="message"
              :error="!!error.displayNameErrors.length"
              :error-messages="error.displayNameErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.action"
              label="权限action代码"
              removable
              :messages="message"
              :error="!!error.actionErrors.length"
              :error-messages="error.actionErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              label="业务类型"
              v-model="insertData.selectedBusiness"
              single
              :options="businessOptions"
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.description"
              label="描述"
              type="textarea"
              removable
              :messages="message"
              :error="!!error.descriptionErrors.length"
              :error-messages="error.descriptionErrors"
            />
          </div>
        </div>
        <div class="flex md2 offset--md5">
          <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import permissionApi from '../../api/permission'
import businessApi from '../../api/business'

export default {
  data () {
    return {
      insertData: {
        id: null,
        selectedBusiness: '',
        action: '',
        displayName: '',
        description: '',
      },
      message: ['Required field'],
      error: {
        displayNameErrors: [],
        descriptionErrors: [],
        actionErrors: [],
      },
      showId: false,
      title: '新增权限',
      submitButtonStatus: true,
      businesses: {},
      businessOptions: [],
    }
  },
  created () {
    this.listBusiness()
  },
  computed: {
    formReady () {
      return !this.error.descriptionErrors.length &&
          !this.error.displayNameErrors.length &&
          !this.error.actionErrors.length
    },
  },
  methods: {
    listBusiness () {
      businessApi.listBusiness().then(response => {
        response.businesses.forEach(x => {
          this.businesses[x.displayName + ': ' + x.name] = x.id
          this.businessOptions.push(x.displayName + ': ' + x.name)
        })
      }).catch(error => alert(error))
    },
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      this.changeButtonStatus(false)
      const data = {
        name: this.insertData.name,
        action: this.insertData.action,
        displayName: this.insertData.displayName,
        description: this.insertData.description,
      }
      data.businessId = this.businesses[this.insertData.selectedBusiness]
      permissionApi.createPermission(data).then(response => {
        if (response.success === true) {
          this.showToast('添加权限成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.$router.push({ name: 'listPermission' })
        }
      }).catch(error => {
        this.changeButtonStatus(true)
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    clickCancel () {
    },
    checkField () {
      this.error.displayNameErrors = this.insertData.displayName ? [] : ['displayName is required']
      this.error.descriptionErrors = this.insertData.description ? [] : ['description is required']
      this.error.actionErrors = this.insertData.action ? [] : ['action is required']
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
